/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

/* CONTENT COLLECTIONS ROUTES */
export default [
  {
    name: routeNames.MANAGE_ACCESS_FISH,
    path: 'manage-access/:id',
    component: () => import('@/components/manage-access-card'),
    props: true,
  },
  {
    name: routeNames.MY_CONTENT_CARD_FISH,
    path: 'content',
    component: () =>
      import(
        /* webpackPrefetch: true */ '@/components/my-content/my-content-card'
      ),
    redirect: { name: routeNames.MY_CONTENT_CREATED_FISH },
    children: [
      {
        name: routeNames.MY_CONTENT_CREATED_FISH,
        path: 'created',
        component: () => import('@/components/my-content/created-content'),
      },
      {
        name: routeNames.FAVORITES_FISH,
        path: 'saved',
        component: () => import('@/components/my-content/saved-content'),
      },
    ],
  },
  // WAYPOINT
  {
    name: 'fish-waypoint-create',
    path: 'waypoint/create',
    component: () => import('@/components/waypoint-edit-card'),
    meta: { isCreate: true },
  },
  {
    name: 'fish-waypoint-edit',
    path: 'waypoint/:id/edit',
    component: () => import('@/components/waypoint-edit-card'),
  },
  {
    name: 'fish-waypoint',
    path: 'waypoint/:id',
    component: () => import('@/components/waypoint-view-card'),
    redirect: { name: 'fish-waypoint-overview' },
    children: [
      {
        name: 'fish-waypoint-overview',
        path: 'overview',
        component: () => import('@/components/waypoint-overview-tab'),
        meta: { showWind: false, optimalWind: false, showRangeRadius: false },
      },
    ],
  },
  {
    name: 'fish-waypoint-share',
    path: 'waypoint/:id/share',
    component: () => import('@/components/content-select-card'),
    props: {
      context: 'markup-share',
    },
    meta: { type: 'waypoint' },
  },
  {
    name: 'fish-waypoint-add-to-folder',
    path: 'waypoint/:id/add-to-folder',
    component: () => import('@/components/content-select-card'),
    props: {
      context: 'markup-add-to-collection',
    },
    meta: { type: 'waypoint' },
  },
  {
    name: 'fish-waypoint-photo-quick-add',
    path: 'waypoint/photo-quick-add',
    component: () => import('@/components/markup-photo-quick-add-card'),
  },
  // SHAPE
  {
    name: 'fish-shape-create',
    path: 'shape/create',
    component: () => import('@/components/shape-edit-card'),
    meta: { isCreate: true },
  },
  {
    name: 'fish-shape-edit',
    path: 'shape/:id/edit',
    component: () => import('@/components/shape-edit-card'),
  },
  {
    name: 'fish-shape',
    path: 'shape/:id',
    component: () => import('@/components/shape-view-card'),
  },
  {
    name: 'fish-shape-share',
    path: 'shape/:id/share',
    component: () => import('@/components/content-select-card'),
    props: {
      context: 'markup-share',
    },
    meta: { type: 'shape' },
  },
  {
    name: 'fish-shape-add-to-folder',
    path: 'shape/:id/add-to-folder',
    component: () => import('@/components/content-select-card'),
    props: {
      context: 'markup-add-to-collection',
    },
    meta: { type: 'shape' },
  },
  // LINE
  {
    name: 'fish-line-create',
    path: 'line/create',
    component: () => import('@/components/line-edit-card'),
    meta: { isCreate: true },
  },
  {
    name: 'fish-line-edit',
    path: 'line/:id/edit',
    component: () => import('@/components/line-edit-card'),
  },
  {
    name: 'fish-line',
    path: 'line/:id',
    component: () => import('@/components/line-view-card'),
  },
  {
    name: 'fish-line-share',
    path: 'line/:id/share',
    component: () => import('@/components/content-select-card'),
    props: {
      context: 'markup-share',
    },
    meta: { type: 'line' },
  },
  {
    name: 'fish-line-add-to-folder',
    path: 'line/:id/add-to-folder',
    component: () => import('@/components/content-select-card'),
    props: {
      context: 'markup-add-to-collection',
    },
    meta: { type: 'line' },
  },
  // COLLECTION
  {
    name: 'all-collections-card-fish',
    path: 'content/folders',
    component: () => import('@/components/all-collections-card'),
  },
  {
    name: 'collection-details-fish',
    path: 'content/folder-details/:id',
    component: () => import('@/components/content-collection-details'),
  },
  {
    name: 'all-collections-card-fish',
    path: 'content/folders',
    component: () => import('@/components/all-collections-card'),
  },
  {
    name: 'content-select-fish',
    path: 'content/select/:id',
    component: () => import('@/components/content-select-card'),
    props: {
      context: 'collection-details',
    },
  },
  {
    name: 'content-select-unspecified-collection-fish',
    path: 'content/:type/select',
    component: () => import('@/components/content-select-card'),
    props: {
      context: 'unspecified-collection',
    },
  },

  {
    name: 'fish-trim-track-card',
    path: 'trim-track/:id',
    component: () => import('@/components/trim-track-card'),
    props: true,
  },
  // MARKUPS
  {
    name: 'all-markups-card-fish',
    path: 'content/all',
    component: () => import('@/components/all-markups-card'),
  },
  {
    name: 'markup-type-list-card-waypoints-fish',
    path: 'content/waypoints',
    component: () => import('@/components/markup-type-list-card'),
    props: { type: 'waypoint' },
  },
  {
    name: 'markup-type-list-card-tracks-fish',
    path: 'content/tracks',
    component: () => import('@/components/markup-type-list-card'),
    props: { type: 'track' },
  },
  {
    name: 'markup-type-list-card-areas-fish',
    path: 'content/areas',
    component: () => import('@/components/markup-type-list-card'),
    props: { type: 'shape' },
  },
  {
    name: 'markup-type-list-card-lines-fish',
    path: 'content/lines',
    component: () => import('@/components/markup-type-list-card'),
    props: { type: 'line' },
  },
  {
    name: 'markup-type-list-card-routes-fish',
    path: 'content/routes',
    component: () => import('@/components/markup-type-list-card'),
    props: { type: 'route' },
  },
  {
    name: 'filter-content-fish',
    path: 'content/filter',
    component: () => import('@/components/content-filter-card'),
  },
  // IMPORT
  {
    name: 'import-fish',
    path: 'content/import',
    component: () => import('@/components/import-card'),
  },
  {
    name: 'import-success-fish',
    path: 'content/import-success',
    component: () => import('@/components/import-success-card'),
  },
  // FAVORITING
  {
    name: routeNames.FAVORITE_LAKES,
    path: 'content/lakes',
    component: () =>
      import('@/components/favorites/favorite-types/favorite-lakes'),
    props: true,
  },
  {
    name: routeNames.FAVORITE_WATER_ACCESS,
    path: 'content/water-access',
    component: () =>
      import('@/components/favorites/favorite-types/favorite-water-access'),
    props: true,
  },
  {
    name: routeNames.FAVORITE_FISHING_AREA,
    path: 'content/fishing-areas',
    component: () =>
      import('@/components/favorites/favorite-types/favorite-fishing-area'),
    props: true,
  },
  {
    path: 'mobile-tools',
    name: 'fish-mobile-tools',
    component: () => import('@/components/mobile-prototyping/tools-card'),
  },
  {
    name: 'content-share-accept-fish',
    path: 'share/:shareID',
    component: () => import('@/components/share-accept-modal.vue'),
  },
]
